// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"b2d64a42f18fbe9351f8","691":"794ec0cd3b33e07fd53d"}[chunkId] + ".js";
};